export const Types = {
  SAVE_LIST_USER_ADMIN: 'SAVE_LIST_USER_ADMIN',
  SAVE_LIST_TASK : 'SAVE_LIST_TASK',
  SAVE_WALLET_HISTORY: 'SAVE_WALLET_HISTORY'
}
